<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-7.15,799.77l-2.35-2.35v-9.85l2.35-2.35h15.3l2.35,2.35v9.85l-2.35,2.35H-7.15z M-4.84,796.78l4.28-4.28l-4.28-4.28
	l-1.29,1.28l2.99,2.99l-2.99,2.99L-4.84,796.78z M2.37,796.46l1.71-0.64l-2.73-7.27l-1.71,0.64L2.37,796.46z M6.01,796.46l1.71-0.64
	l-2.73-7.27l-1.7,0.64L6.01,796.46z"/>
</svg>

</template>